// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1_XLa","left":"StickyBox_left__1H5bA","right":"StickyBox_right__1YyQT"};